import { AuthenticationApi } from "bonusx-api-auth-manager";
import { useEffect, useState } from "react";

import { AbacGuardService } from "../";
import { authApiConfig_v1 } from "../../../../constants/env";
import { useIsLogged } from "../../../../hooks/auth/use-is-logged/use-is-logged";
import { ONBOARDING_SURVEY_PATH } from "../../../../legacy/pages/survey/config/survey-paths";
import { addContextIdToPathOrDefault } from "../../../../legacy/pages/survey/utils/add-context-id-to-path";
import axiosInstance from "../../../../legacy/services/axios-config-singleton/axios-config-singleton.instance";

interface IUseMobileOnboardingGuard {
  isLogged: boolean;
  loading: boolean;
  error: unknown;
  onboardingPath: string;
}

async function initMobileOnboarding(signal: AbortSignal, onDone: () => void): Promise<void> {
  const authenticationApi = new AuthenticationApi(authApiConfig_v1, undefined, axiosInstance);
  const { data } = await authenticationApi.getAbilityRules();
  AbacGuardService.getInstance().setAbility(data);

  if (!signal.aborted) {
    onDone();
  }
}

export function useMobileOnboardingGuard(): IUseMobileOnboardingGuard {
  const isLogged = useIsLogged();
  const [loading, setLoading] = useState(isLogged);
  const [error, setError] = useState<unknown>(null);

  const onboardingPath = addContextIdToPathOrDefault(ONBOARDING_SURVEY_PATH);

  useEffect(
    function runMobileOnboardingGuard() {
      setError(null);

      if (!isLogged) {
        setLoading(false);
        return;
      }

      setLoading(true);
      const controller = new AbortController();

      function onDone(): void {
        setLoading(false);
      }

      function onError(err: unknown): void {
        if (!controller.signal.aborted) {
          setLoading(false);
          setError(err);
        }
      }

      initMobileOnboarding(controller.signal, onDone).catch(onError);

      return function cancelGuardInit() {
        controller.abort();
      };
    },
    [isLogged]
  );

  return { isLogged, loading, error, onboardingPath };
}
